export const selectDocuments = state => state.documents.documents;
export const selectDocumentsSyncing = state => state.documents.syncing;
